"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var core_2 = require("@ngx-translate/core");
var flex_layout_1 = require("@angular/flex-layout");
var material_module_1 = require("../material.module");
var core_module_1 = require("../core/core.module");
var shared_module_1 = require("../shared/shared.module");
var patient_selection_routing_module_1 = require("./patient-selection.routing.module");
var patient_selection_component_1 = require("./patient-selection.component");
var PatientSelectionModule = /** @class */ (function () {
    function PatientSelectionModule() {
    }
    PatientSelectionModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [
                common_1.CommonModule,
                core_2.TranslateModule,
                core_module_1.CoreModule,
                shared_module_1.SharedModule,
                flex_layout_1.FlexLayoutModule,
                material_module_1.MaterialModule,
                patient_selection_routing_module_1.PatientSelectionRoutingModule
            ],
            declarations: [
                patient_selection_component_1.PatientSelectionComponent
            ],
            providers: []
        })
    ], PatientSelectionModule);
    return PatientSelectionModule;
}());
exports.PatientSelectionModule = PatientSelectionModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aWVudC1zZWxlY3Rpb24ubW9kdWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicGF0aWVudC1zZWxlY3Rpb24ubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHNDQUF5QztBQUN6QywwQ0FBK0M7QUFDL0MsNENBQXNEO0FBQ3RELG9EQUF3RDtBQUV4RCxzREFBb0Q7QUFDcEQsbURBQWlEO0FBQ2pELHlEQUF1RDtBQUN2RCx1RkFBbUY7QUFDbkYsNkVBQTBFO0FBaUIxRTtJQUFBO0lBQ0EsQ0FBQztJQURZLHNCQUFzQjtRQWZsQyxlQUFRLENBQUM7WUFDTixPQUFPLEVBQUU7Z0JBQ0wscUJBQVk7Z0JBQ1osc0JBQWU7Z0JBQ2Ysd0JBQVU7Z0JBQ1YsNEJBQVk7Z0JBQ1osOEJBQWdCO2dCQUNoQixnQ0FBYztnQkFDZCxnRUFBNkI7YUFDaEM7WUFDRCxZQUFZLEVBQUU7Z0JBQ1YsdURBQXlCO2FBQzVCO1lBQ0QsU0FBUyxFQUFFLEVBQUU7U0FDaEIsQ0FBQztPQUNXLHNCQUFzQixDQUNsQztJQUFELDZCQUFDO0NBQUEsQUFERCxJQUNDO0FBRFksd0RBQXNCIn0=


//////////////////
// WEBPACK FOOTER
// ./src/app/patient-selection/patient-selection.module.ts
// module id = 626
// module chunks = 0